(function () {
    'use strict';

    angular.module("imApp").factory("custactCalcAdjustDiscService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1249,
                    parameters: parms || {}
                });
            },
            executeObj: function (edit) {
                return $ihttp.post({
                    method: 1250,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
